var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcrightarrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "27px",
    viewBox: "0 0 17 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icrightarrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-1.3%",
    y: "-5.3%",
    width: "102.7%",
    height: "113.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M10.7400881,20.5 C10.5374449,20.5 10.3601322,20.4249084 10.2081498,20.2747253 L0,10.2124542 L10.1321586,0.225274725 C10.4361233,-0.0750915751 10.9174009,-0.0750915751 11.1960352,0.225274725 C11.5,0.525641026 11.5,1.001221 11.1960352,1.27655678 L2.1530837,10.2124542 L11.2720264,19.2234432 C11.5759912,19.5238095 11.5759912,19.9993895 11.2720264,20.2747253 C11.1200441,20.4249084 10.9427313,20.5 10.7400881,20.5 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-settings",
    transform: "translate(-19.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/nav-with-currency"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-nav-copy-2",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/right-arrow",
    transform: "translate(28.500000, 48.500000) scale(-1, 1) translate(-28.500000, -48.500000) translate(16.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(13.750000, 12.750000) scale(-1, 1) translate(-13.750000, -12.750000) translate(8.000000, 2.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#010101",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.500000, -4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27,
    height: 28
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcrightarrow);
export default __webpack_public_path__ + "static/media/Icrightarrow.23b4202b6fbaf04b4262fe75f68c9f0e.svg";
export { ForwardRef as ReactComponent };